import { render } from "./searchShops.vue?vue&type=template&id=390c29c5"
import script from "./searchShops.vue?vue&type=script&lang=js"
export * from "./searchShops.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__